const hidePriceSkus = [
    '634236', '46487', '716183', '639463', '685358', '668969', '100738',
    '719188', '719184', '719187', '868233', '868258', '100739', '719181',
    '719186', '719189', '719185', '716182', '604330', '648610', '878088',
    '716181', '604328',
];

export default hidePriceSkus;
